import React from 'react';
import './About.css';
import { useNavigate } from 'react-router-dom';
import SEO from 'component/SEO/SEO';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-14">
      <SEO
        title="About Us"
        description="Rekha Collection - Kolkata's trusted fashion store at Jothbhim Road, Hatgacha, Newtown. Founded by Sudeshna Mazumder. Quality saree, kurti, suit at best prices. Free delivery in Kolkata & West Bengal. রেখা কালেকশন সম্পর্কে জানুন।"
        keywords="rekha collection about, rekha collection kolkata address, rekha collection newtown, hatgacha fashion store, sudeshna mazumder, রেখা কালেকশন ঠিকানা, হাটগাছা নিউটাউন"
        url="/About"
      />
      <div className="columnthumbsup">
        <div className="columnaboutus-15">
          {/* About Us Section */}
          <h1 className="aboutus-15 ui heading size-heading3xl">
            <span className="elevateyour-span">About&nbsp;</span>
            <span className="aboutus-span-1">Us</span>
          </h1>
          <p className="description-14 ui text size-text2xl">
            Welcome to Rekha Collection! Located at Jothbhim Road, Hatgacha, Newtown, Kolkata, we are dedicated to bringing you an exquisite range of garments that blend tradition with modern style. Founded by Sudeshna Mazumder, our mission is to provide high-quality clothing—from elegant sarees and stylish kurtis to comfortable everyday wear—at prices that fit your budget. We believe that everyone deserves to look and feel their best, and we take pride in offering handpicked collections with the best designs, quality, and unbelievable value.
          </p>

          {/* Terms & Condition Section */}
          <h2 className="termscondition ui heading size-heading3xl">
            <span className="elevateyour-span">Terms&nbsp;</span>
            <span className="termscondition-span-1">&amp; Condition</span>
          </h2>
          <p className="description-14 ui text size-text2xl">
            Access to and use of https://rekhacollection.in and the products and services available through the website are subject to the following terms, conditions, and notices (”Terms of Service”). By browsing through these Terms of Service and using the services provided by our website https://rekhacollection.in, you agree to all Terms of Service along with the Privacy Policy on our website, which may be updated by us from time to time. Please check this page regularly to take notice of any changes we may have made to the Terms of Service.
          </p>

          {/* Privacy Policy Section */}
          <a href="#" className="privacypolicy-link">
            <h3 className="privacypolicy ui heading size-heading3xl">
              <span className="elevateyour-span">Privacy&nbsp;</span>
              <span className="aboutus-span-1">Policy</span>
            </h3>
          </a>
          <p className="description-14 ui text size-text2xl">
            <span className="description-span-6">1.1</span>
            <span className="aboutus-span-1">&nbsp;</span>
            <span className="elevateyour-span">
              Information Collection: We collect personal information such as your name, shipping address, and contact details when you make a purchase or create an account. This information is strictly used to process your orders efficiently and improve your shopping experience.
            </span>
          </p>
          <p className="description-14 ui text size-text2xl">
            <span className="description-span-6">1.2</span>
            <span className="description-span-10">&nbsp;</span>
            <span className="elevateyour-span">
              Data Security: Your privacy is our priority. Your payment information is securely processed. We do not store your sensitive financial details, nor do we sell or share your personal information with third parties for their marketing purposes.
            </span>
          </p>
          <p className="description-14 ui text size-text2xl">
            <span className="description-span-6">1.3</span>
            <span className="description-span-10">&nbsp;</span>
            <span className="elevateyour-span">
              Communication: We may use your email or phone number to send order updates, shipping confirmations, and occasional promotional offers. You reserve the right to opt out of our promotional communications at any time.
            </span>
          </p>

          {/* Shopping Policy Section */}
          <h4 className="termscondition ui heading size-heading3xl">
            <span className="elevateyour-span">Shopping&nbsp;</span>
            <span className="aboutus-span-1">Policy</span>
          </h4>
          <p className="description-19 ui text size-text2xl">
            • All orders are processed and dispatched within 1-2 business days.
            <br />
            • We offer reliable delivery across Kolkata and standard shipping nationwide.
            <br />
            • Product availability is subject to change. If an item becomes out of stock after an order is placed, our team will notify you promptly.
            <br />
            • Please note that the colors of garments may vary slightly due to photographic lighting sources or your monitor/screen settings.
            <br />
            • We accept all major UPI payments, credit/debit cards, and Cash on Delivery (where applicable).
          </p>

          {/* Return & Exchange Policy Section */}
          <h5 className="returnexchange ui heading size-heading3xl">
            <span className="elevateyour-span">Return&nbsp;</span>
            <span className="elevateyour-span">&amp;</span>
            <span className="elevateyour-span">&nbsp;Exchange&nbsp;</span>
            <span className="aboutus-span-1">Policy</span>
          </h5>
          <p className="description-20 ui text size-text2xl">
            • We accept returns and exchanges within 3 days of the delivery date.
            <br />
            • To be eligible for a return or exchange, garments must be unused, unwashed, and in their original packaging with all tags intact.
            <br />
            • Please note that sarees with the blouse piece detached, or with fall/picot stitching already done, cannot be returned or exchanged.
            <br />
            • To initiate a return, please contact our support team with your order number and the reason for the return.
            <br />
            • A processing fee of ₹100 will be applicable for all refunds and replacements.
          </p>

          {/* Contact Us Section */}
          <a href="#" className="contactus-link">
            <h6 className="privacypolicy ui heading size-heading3xl">
              <span className="elevateyour-span">Contact</span>
              <span className="aboutus-span-1">&nbsp;Us</span>
            </h6>
          </a>
          <p className="description-21 ui text size-text2xl">
            <span className="description-span-4">
              Reach Us Out - We're all ears!
              <br />
            </span>
            <span>
              Do you have a question? Need help with your order? Want to share feedback? Our support team is here for you.
              <br />
              <strong>Store Address:</strong> Jothbhim Road, Hatgacha, Newtown, Kolkata
              <br />
              <strong>WhatsApp Support:</strong> 7003981213
              <br />
              <strong>Email Support:</strong> rekhacollectionofficial@gmail.com
              <br />
              <strong>Working Hours:</strong> 11am - 7pm IST Monday to Saturday.
              <br />
              <br />
              Note: Queries received outside working hours will be addressed on the next working day.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;